// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader__loader-a1d07e {
  animation: Loader__rotating-bacb28 2s linear infinite;
  vertical-align: bottom;
  overflow: hidden;
}

.Loader__loader-a1d07e stop {
  stop-color: currentColor;
}

.Loader__color--current-f63bc5 {
  color: currentColor;
}

.Loader__color--primary-bbea2d {
  color: var(--addition-50);
}

.Loader__color--base-eccba3 {
  color: var(--base-120);
}

.Loader__color--secondary-eb2fe3 {
  color: var(--brand-secondary-40);
}

.Loader__color--brand-primary-a30a92 {
  color: var(--brand-primary-40);
}

.Loader__color--base-80-e7b16b {
  color: var(--base-80);
}

.Loader__big-b9842a {
  width: 32px;
  height: 32px;
}

.Loader__medium-ff136e {
  width: 24px;
  height: 24px;
}

.Loader__small-feda7a {
  width: 16px;
  height: 16px;
}

@-webkit-keyframes Loader__rotating-bacb28 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes Loader__rotating-bacb28 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Loader/Loader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qDAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,uBAAA;EACF;EACA;IACE,yBAAA;EACF;AACF;AACA;EACE;IACE,uBAAA;EACF;EACA;IACE,yBAAA;EACF;AACF","sourcesContent":[".loader {\n  animation: rotating 2s linear infinite;\n  vertical-align: bottom;\n  overflow: hidden;\n}\n\n.loader stop {\n  stop-color: currentColor;\n}\n\n.color--current {\n  color: currentColor;\n}\n\n.color--primary {\n  color: var(--addition-50);\n}\n\n.color--base {\n  color: var(--base-120);\n}\n\n.color--secondary {\n  color: var(--brand-secondary-40);\n}\n\n.color--brand-primary {\n  color: var(--brand-primary-40);\n}\n\n.color--base-80 {\n  color: var(--base-80);\n}\n\n.big {\n  width: 32px;\n  height: 32px;\n}\n\n.medium {\n  width: 24px;\n  height: 24px;\n}\n\n.small {\n  width: 16px;\n  height: 16px;\n}\n\n@-webkit-keyframes rotating {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotating {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `Loader__loader-a1d07e`,
	"rotating": `Loader__rotating-bacb28`,
	"color--current": `Loader__color--current-f63bc5`,
	"colorCurrent": `Loader__color--current-f63bc5`,
	"color--primary": `Loader__color--primary-bbea2d`,
	"colorPrimary": `Loader__color--primary-bbea2d`,
	"color--base": `Loader__color--base-eccba3`,
	"colorBase": `Loader__color--base-eccba3`,
	"color--secondary": `Loader__color--secondary-eb2fe3`,
	"colorSecondary": `Loader__color--secondary-eb2fe3`,
	"color--brand-primary": `Loader__color--brand-primary-a30a92`,
	"colorBrandPrimary": `Loader__color--brand-primary-a30a92`,
	"color--base-80": `Loader__color--base-80-e7b16b`,
	"colorBase80": `Loader__color--base-80-e7b16b`,
	"big": `Loader__big-b9842a`,
	"medium": `Loader__medium-ff136e`,
	"small": `Loader__small-feda7a`
};
module.exports = ___CSS_LOADER_EXPORT___;
